import { FilterableDimension } from 'modules/analytics/models/dimensions/FilterableDimension';
export var UserDimensionCategory;
(function (UserDimensionCategory) {
    UserDimensionCategory["All"] = "all";
    UserDimensionCategory["Active"] = "active";
    UserDimensionCategory["Recurrents"] = "recurrents";
})(UserDimensionCategory || (UserDimensionCategory = {}));
export class UserDimension extends FilterableDimension {
    static $inject = ['init'];
    constructor(init) {
        super();
        Object.assign(this, {
            type: UserDimensionCategory.All,
            ...init,
        });
    }
}
UserDimension.$inject = ['init'];
